import './CheckboxInput.css';

import { IonLabel } from '@ionic/react';
import { Checkbox } from '../../../../Checkbox';
import { CheckboxSelectControl } from '../../../../../types/types';
import type { GridInputBaseProps } from '../../types';

type CheckboxInputProps = Pick<
  GridInputBaseProps<boolean>,
  'onChange' | 'onTouch' | 'onFocusIn' | 'onFocusOut' | 'disabled'
> & {
  label: string | undefined;
  value: boolean;
  control: CheckboxSelectControl;
};

const CheckboxInput = ({
  label,
  onChange,
  onTouch,
  onFocusIn,
  onFocusOut,
  value,
  control,
  disabled,
}: CheckboxInputProps) => {
  const onCheckboxChange = (checkboxValue: boolean) => {
    const value = control?.inverse ? !checkboxValue : checkboxValue;
    onChange(value);
    onTouch?.(value);
  };
  return (
    <div
      className="form-input checkbox-input input-container"
      onFocus={onFocusIn}
      onBlur={onFocusOut}
    >
      <Checkbox
        disabled={disabled}
        onChange={onCheckboxChange}
        value={control?.inverse ? !value : value}
        color="secondary"
        // label={label}
      />
      {label && <IonLabel className="checkbox-input-label">{label}</IonLabel>}
    </div>
  );
};

export default CheckboxInput;
